export const initNumberOfResultsFilter = (selectedCodes: number) => {
  if (selectedCodes <= 10) {
    return 10;
  } else if (selectedCodes <= 15) {
    return 15;
  } else if (selectedCodes <= 25) {
    return 25;
  } else {
    return 10000;
  }
};
